import { render } from "./ListeMarquePage.vue?vue&type=template&id=627e02bb&ts=true"
import script from "./ListeMarquePage.vue?vue&type=script&lang=ts"
export * from "./ListeMarquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__